/*
 * /producer (list page)
 */
import {
	Button,
	Card,
	CardContent,
	Container,
	Page,
	PageHeader,
	Placeholder,
} from "@emr/react-ui"
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router"
import { Building2, ChevronRight, Plus } from "lucide-react"
import { trpc } from "../../trpc"

export const Route = createFileRoute("/producer/")({
	component: ProducerListPage,
})

function ProducerListPage() {
	const navigate = useNavigate()

	const { data: producers, isLoading } = trpc.producer.getAllByFilter.useQuery({
		where: { active: true },
	})

	return (
		<Page>
			<Container width="xl" padding="lg" gap="lg">
				<PageHeader
					title="Producers"
					right={{
						Component: (
							<Button onClick={() => navigate({ to: "/producer/new" })}>
								<Plus className="w-4 h-4 mr-1" />
								New Producer
							</Button>
						),
					}}
				/>

				{isLoading ? (
					<Placeholder title="Loading..." />
				) : !producers || producers.length === 0 ? (
					<Placeholder title="No producers yet" />
				) : (
					<div className="flex flex-col gap-3">
						{producers.map((producer) => (
							<Link
								key={producer.id}
								to="/producer/$producerId"
								params={{ producerId: producer.id }}
								className="block"
							>
								<Card className="hover:bg-accent/50 transition-colors cursor-pointer">
									<CardContent className="flex items-center justify-between py-4">
										<div className="flex items-center gap-3">
											<Building2 className="w-5 h-5 text-muted-foreground shrink-0" />
											<div>
												<p className="font-medium">{producer.name}</p>
												{producer.shortName && (
													<p className="text-sm text-muted-foreground">
														{producer.shortName}
													</p>
												)}
											</div>
										</div>
										<ChevronRight className="w-4 h-4 text-muted-foreground" />
									</CardContent>
								</Card>
							</Link>
						))}
					</div>
				)}
			</Container>
		</Page>
	)
}
